// extracted by mini-css-extract-plugin
export default {"wrapper":"DocPage_wrapper__BJaT6"};